/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { count } from '../fn/sub-account/count';
import { Count$Params } from '../fn/sub-account/count';
import { getSubAccountTypes } from '../fn/sub-account/get-sub-account-types';
import { GetSubAccountTypes$Params } from '../fn/sub-account/get-sub-account-types';
import { SubAccountTypeBoView } from '../models/sub-account-type-bo-view';


/**
 * Sub account operations
 */
@Injectable({ providedIn: 'root' })
export class SubAccountService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `count()` */
  static readonly CountPath = '/sub-accounts/count';

  /**
   * Counts sub account types
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: Count$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return count(this.http, this.rootUrl, params, context);
  }

  /**
   * Counts sub account types
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: Count$Params, context?: HttpContext): Observable<number> {
    return this.count$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `getSubAccountTypes()` */
  static readonly GetSubAccountTypesPath = '/sub-account-types';

  /**
   * Sub account list
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubAccountTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubAccountTypes$Response(params?: GetSubAccountTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubAccountTypeBoView>>> {
    return getSubAccountTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * Sub account list
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubAccountTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubAccountTypes(params?: GetSubAccountTypes$Params, context?: HttpContext): Observable<Array<SubAccountTypeBoView>> {
    return this.getSubAccountTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubAccountTypeBoView>>): Array<SubAccountTypeBoView> => r.body)
    );
  }

}
